// extracted by mini-css-extract-plugin
module.exports = {"cinemaWeek":"CinemaWeek_cinemaWeek__fQZ18","appearance":"CinemaWeek_appearance__tB_M1","disappearance":"CinemaWeek_disappearance__Dj2tI"};